/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Navigate } from 'react-router';

import { BasicRoutes } from '../../constants/basicRoutes';
import { RootState } from '../../store';

const mapState = (state: RootState) => ({
  auth: state.auth,
});

const connector = connect(mapState);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface HURouteProps extends PropsFromRedux {
  privateRoute?: boolean;
  guestRoute?: boolean;
  children: React.ReactNode;
}

const HURouteComponent = memo<HURouteProps>(props => {
  const { auth, privateRoute, guestRoute, children } = props;

  if (privateRoute && !auth.isAuthenticated) {
    return <Navigate to={BasicRoutes.LOGIN} />;
  } else if (guestRoute && auth.isAuthenticated) {
    return <Navigate to={BasicRoutes.HOME} />;
  }

  return children;
});

export const HURoute = connector(HURouteComponent);
